import { theme } from 'theme/theme';

/*
  "grayscale" theme (VictoryTheme.grayscale)
  The grayscale is the default theme.
  Try changing it. You could start with `color` or `fontSize`.
*/

// Colors
const colorScale = ['rgba(255,255,255,0.5)'];
export const colorWhiteTransp = 'rgba(255,255,255,0.5)';
export const colorDeepSkyBlueTransp = 'rgba(5,189,255,0.5)';
export const colorEmerald = '#45D36D';
export const colorWhite = '#FFFFFF';
export const colorLightBlue = '#05BDFF';

// Typography
const letterSpacing = 'normal';
const fontSize = 13;

// Layout
const baseProps = {
    width: 450,
    height: 300,
    padding: 50,
    colorScale,
};

// Labels
export const baseLabelStyles = {
    fontFamily: theme.font.regular,
    fontSize,
    letterSpacing,
    padding: 10,
    fill: colorWhite,
    stroke: 'transparent',
};
const centeredLabelStyles = { textAnchor: 'middle', ...baseLabelStyles };

// Strokes
const strokeLinecap = 'round';
const strokeLinejoin = 'round';

// Put it all together...
export const chartTheme = {
    axis: {
        ...baseProps,
        style: {
            axis: {
                fill: 'transparent',
                stroke: theme.color.gray3,
                strokeWidth: 1,
                strokeLinecap,
                strokeLinejoin,
            },
            axisLabel: {
                ...centeredLabelStyles,
                fontWeight: 'bold',
            },
            grid: {
                fill: 'none',
                strokeWidth: 0.8,
                stroke: theme.color.gray3,
                pointerEvents: 'visible',
            },
            ticks: {
                fill: 'transparent',
                strokeWidth: 0.8,
                stroke: theme.color.gray3,
            },
            tickLabels: {
                ...baseLabelStyles,
                fill: colorWhiteTransp,
                fontSize: 11,
            },
        },
    },
    bar: {
        ...baseProps,
        style: {
            data: {
                fill: colorWhiteTransp,
                strokeWidth: 0,
            },
            labels: {
                ...baseLabelStyles,
                fontSize: 11,
                fill: 'black',
            },
        },
    },

    chart: baseProps,
    errorbar: {
        ...baseProps,
        borderWidth: 8,
        style: {
            data: {
                fill: 'transparent',
                stroke: theme.color.gray3,
                strokeWidth: 2,
            },
            labels: centeredLabelStyles,
        },
    },
    group: {
        ...baseProps,
        colorScale,
    },

    line: {
        ...baseProps,
        style: {
            data: {
                fill: 'transparent',
                stroke: theme.color.gray3,
                strokeWidth: 2,
            },
            labels: centeredLabelStyles,
        },
    },

    tooltip: {
        style: {
            ...centeredLabelStyles,
            padding: 5,
            pointerEvents: 'none',
        },
        flyoutStyle: {
            stroke: theme.color.gray3,
            strokeWidth: 1,
            fill: 'black',
            pointerEvents: 'none',
        },
        cornerRadius: 2,
        pointerLength: 5,
        pointerWidth: 10,
    },

    legend: {
        colorScale: theme.color,
        orientation: 'vertical',
        titleOrientation: 'top',
        style: {
            data: {
                type: 'circle',
            },
            labels: baseLabelStyles,
            title: { ...baseLabelStyles, padding: 5 },
        },
    },
};

export const chartLabelStyles = {
    textAnchor: 'start',
    fill: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    padding: 0,
};

export const getGridStroke = (them) => (datum) => {
    return datum.tickValue % 2 ? them.color.grayDark2 : them.color.grayDark;
};

export const chartPadding = { left: 40, right: 40, top: 40, bottom: 70 };
